<template>
    <Teleport to="#vat-receipt-toggle-container">
        <!-- The toggle only appears if autoPrintReceipts is enabled because it's useless without that. -->
        <Toggle v-if="taxEnabled && autoPrintReceiptsEnabled"
                v-model="checked"
                :disabled="toggleDisabled"
                name="vat-receipt-toggle"
                label="PAYMENT.VAT_RECEIPT"
                @click="onClick">
            <i v-if="toggleDisabled"
               class="fa-solid fa-exclamation-triangle mr-05 text-warning"></i>
        </Toggle>
    </Teleport>
</template>

<script>
import TaxReceiptUnavailableReasonEnum from '@/lib/Tax/TaxReceiptUnavailableReasonEnum';
import Toggle from '@/vue/components/Forms/Toggle';
import { container } from '@/container';
import { mapState } from 'vuex';

export default {
    components: {
        Toggle,
    },

    data() {
        return {
            autoPrintReceiptsEnabled: false,
            taxEnabled: false,

            /**
             * @type {string|false}
             */
            taxReceiptMandatoryReason: false,

            checked: container.orderReceiptPrinter.autoPrintTaxReceipts,
        };
    },

    computed: {
        ...mapState(['isOnline']),

        taxReceiptMandatory() {
            return !!this.taxReceiptMandatoryReason;
        },

        taxReceiptUnavailableReason() {
            if (!this.isOnline) {
                return TaxReceiptUnavailableReasonEnum.OFFLINE_DURING_SALE;
            }

            return false;
        },

        taxReceiptUnavailable() {
            return !!this.taxReceiptUnavailableReason;
        },

        toggleDisabled() {
            return this.taxReceiptMandatory || this.taxReceiptUnavailable;
        },
    },

    watch: {
        checked(newVal) {
            container.orderReceiptPrinter.setAutoPrintTaxReceipts(!!newVal);
        },

        taxReceiptUnavailableReason(newVal) {
            if (newVal) {
                this.checked = false;
            } else if (this.taxReceiptMandatory) {
                this.checked = true;
            }
        },
    },

    created() {
        const userService = container.userService;

        this.autoPrintReceiptsEnabled = container.currentDevice.getDevice().autoPrintReceipts();

        this.taxEnabled = userService.getCompany().taxEnabled;

        this.taxReceiptMandatoryReason = container.taxManager.mustPrintTaxReceiptForCart(
            container.userService.getCompany(),
            container.cartService.currentCart
        );

        if (this.taxReceiptMandatory) {
            this.checked = true;
        }

        if (this.taxReceiptUnavailable) {
            this.checked = false;
        }
    },

    methods: {
        onClick() {
            if (this.taxReceiptUnavailable) {
                container.taxManager.showTaxReceiptUnavailableAlert(this.taxReceiptUnavailableReason);
                return;
            }

            if (this.taxReceiptMandatory) {
                container.taxManager.showTaxReceiptRequiredAlert(this.taxReceiptMandatoryReason);
            }
        },
    },
};
</script>
